// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4196":"c8336447ad5475af","4740":"359e5e9a752dc27a"}[chunkId] + ".css";
};